import { createFileRoute } from "@tanstack/react-router"
import { StripeCompletePage } from "@/pages"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/billing/stripe-complete"
)({
  component: StripeCompletePage,
})
